import User from "@/modules/user";
import { computed } from "vue";

export function useMagicBackgroundFlag() {
  const isMagicBackgroundsEnabled = computed(() => !User.isFromChina());
  return { isMagicBackgroundsEnabled };
}
